// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".backup-availability--card h3[data-v-62a9bed7] {\n  word-break: keep-all;\n  text-align: center;\n}\n.backup-availability--chart[data-v-62a9bed7] {\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
